import { useEffect, useState } from "react";
import SearchSelectBox from "../../../../utils/SearchSelectBox";
import Input from "../../../../Core/Fields/Floating/Input";

const Tab2 = ({ status , vendor_address, shippingAddr }) => {    
  const [editableVendorAddress, setEditableVendorAddress] = useState({});
  useEffect(() => {
    if (vendor_address.currentAddress) {
      setEditableVendorAddress(vendor_address.currentAddress);
    }
  }, [vendor_address.currentAddress]);
  

  const changeaddress = (name) =>{
    const filterdata = vendor_address.vendor_address_list.filter((item)=>item.name == name);
    vendor_address.setselect_vendor_address(filterdata[0])
  }
  const changeaddress2 = (name) =>{
    const filterdata = shippingAddr.shippingAddresseslist.filter((item)=>item.name == name);
    shippingAddr.setVendorshipAddress(filterdata[0])
  }
 
  const handleVendorChange = (field, value) => {
    setEditableVendorAddress(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="row m-0" style={{ padding: "8px", borderRadius: "5px" }}>
      <div className="col-12">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>
            Supplier Address
          </p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>
{status == 'New' &&(
      <div className="col-md-4 mt-0">
        <div className="mb-3">
          <SearchSelectBox
            list={vendor_address.vendor_address_list}
            setvalue={changeaddress}
            // setvalue={vendor_address.setselect_vendor_address}
            name="Select Supplier Address"
            
          />
        </div>
      </div>
)}
      {["address_line1", "address_line2", "city", "state", "country", "pincode", "phone"].map((field, idx) => (
        <div className="col-md-4 mt-0 mb-2" key={idx}>
        <Input id="orderdatepo" style={{ height: "30px" }} label={field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())} className="custom-readonly" readOnly disabled={status !== 'New'} value={editableVendorAddress[field] || ""}  onChange={(e) => handleVendorChange(field, e.target.value)}
 />


        </div>
      ))}

      <div className="col-12 mt-3">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>
            Shipping Address
          </p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>

      <div className="col-md-4 mt-0">
      {/* <Input id="orderdatepo" style={{ height: "30px" }} label="Shipping Address" className="custom-readonly" disabled={status !== 'New' && !shippingAddr?.currentAddress}  value={shippingAddr?.currentAddress || ""}   /> */}
        {status == 'New' ? (
          <SearchSelectBox
            list={shippingAddr?.shippingAddresseslist == null ? [] : shippingAddr?.shippingAddresseslist }
            setvalue={changeaddress2}
            name="Select Shipping Address"
            
          />) : <Input id="orderdatepo" style={{ height: "30px" }} label="Shipping Address" className="custom-readonly" readOnly disabled={status !== 'New'} value={shippingAddr?.currentAddress?.name || ""}   />}
        {/* <div className="mb-3">
          <div className="form-floating">
            <input
              type="text"
              className="form-control p-0 px-2"
              style={{ fontSize: '0.8rem', height: "30px" }}
              value={shippingAddr.currentAddress || ""}
              onChange={(e) => shippingAddr.setShipping_address(e.target.value)}
              id="shipping-address"
              placeholder="Shipping Address"
              disabled={status !== 'Draft'}
            />
            <label htmlFor="shipping-address" style={{ fontSize: '0.8rem', color: "#212529a6" }}>
              Shipping Address
            </label>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Tab2;
